<template>
  <div class="home-container">
    <div class="home-content">
      <!-- 搜索 -->
      <div>
        <el-form :model="searchForm" ref="searchForm" label-width="80px">
          <el-row>
            <el-col :span="8">
              <el-form-item label="工单编号" prop="orderWorkNo" style="width: 80%">
                <el-input
                  v-model="searchForm.orderWorkNo"
                  placeholder="请输入工单编号"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-button
                size="small"
                @click="onLoad"
                type="primary"
                icon="el-icon-search"
                style="width: 90px"
                >搜索</el-button
              >
              <el-button
                size="small"
                @click="restSearch"
                type="danger"
                style="width: 90px"
                >重置</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div style="margin: 20px"></div>

      <el-table
        border
        :data="tableData"
        v-loading="isShowloading"
        style="width: 100%"
      >
        <el-table-column prop="orderWorkNo" label="订单编号" align="center">
        </el-table-column>
        <el-table-column prop="orderCategoryName" label="报事类型" align="center">
        </el-table-column>
        <el-table-column prop="userName" label="报事人" align="center">
        </el-table-column>
        <el-table-column prop="phone" label="报事人手机号码" align="center">
        </el-table-column>           
        <el-table-column prop="houseNumber" label="房屋信息" align="center">
        </el-table-column>    
        <el-table-column prop="handleUser" label="受理人" align="center">
        </el-table-column>            
        <el-table-column prop="address" label="报事地址" align="center">
        </el-table-column>  
        <el-table-column prop="createTime" label="报事时间" align="center">
        </el-table-column>  
        <el-table-column prop="evaluateTime" label="评价时间" align="center">
        </el-table-column>    
        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="updata(scope.row)"
              >查看</el-button
            >
          </template>
        </el-table-column>                        
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30,50,100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      <!-- 新增模态框 -->
      <el-dialog
        title="详情"
        :visible.sync="isAddModal"
        width="50%"
        :close-on-click-modal="false"
      >
        <el-form
          ref="form"
          :model="addData"
          label-width="90px"
          :rules="addDataRules"
          label-position="center"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="订单编号"  prop="orderWorkNo">
                <el-input
                  v-model="addData.orderWorkNo"
                  placeholder="无"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="报事类型"  prop="orderCategoryName">
                <el-input
                  v-model="addData.orderCategoryName"
                  placeholder="无"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="报事人"  prop="userName">
                <el-input
                  v-model="addData.userName"
                  placeholder="无"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="房屋信息"  prop="houseNumber">
                <el-input
                  v-model="addData.houseNumber"
                  placeholder="无"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row> 
          <el-row>
            <el-col :span="12">
              <el-form-item label="内容" prop="des">
                <el-input
                  v-model="addData.des"
                  placeholder="无"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="图片" prop="createTime">
                <div v-if="addData.img" v-viewer style="cursor: pointer;">
                  <img
                    :src="item"
                    v-for="(item, ind) in addData.img.split(',')"
                    :key="ind"
                    alt=""
                    style="width: 100px; height: 100px"
                  />
                </div>
              </el-form-item>
            </el-col>
          </el-row>           
          <el-row>
            <el-col :span="12">
              <el-form-item label="受理人"  prop="handleUser">
                <el-input
                  v-model="addData.handleUser"
                  placeholder="无"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="报事地址"  prop="address">
                <el-input
                  v-model="addData.address"
                  placeholder="无"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>  
          <el-row>
            <el-col :span="12">
              <el-form-item label="接收图片"  prop="createTime">
                <div v-if="addData.receiveImg" v-viewer>
                   <img :src="item" v-for="(item,ind) in addData.receiveImg.split(',')" :key="ind" alt=""  style="width:100px;height:100px;">
                </div>                
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="接受备注"  prop="receiveDesc">
                <el-input
                  v-model="addData.receiveDesc"
                  placeholder="无"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>             
          <el-row>
            <el-col :span="12">
              <el-form-item label="报事时间"  prop="createTime">
                <el-input
                  v-model="addData.createTime"
                  placeholder="无"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="完成时间"  prop="completeTime">
                <el-input
                  v-model="addData.completeTime"
                  placeholder="无"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>  
          <el-row>
            <el-col :span="12">
              <el-form-item label="完成图片"  prop="completeImg">
                <div v-if="addData.completeImg" style="cursor: pointer;"  v-viewer>
                   <img :src="item" v-for="(item,ind) in addData.completeImg.split(',')" :key="ind" alt=""  style="width:100px;height:100px;">
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="完成备注"  prop="completeDesc">
                <el-input
                  v-model="addData.completeDesc"
                  placeholder="无"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="评价等级"   prop="evaluateScore">
                <el-select clearable filterable v-model="addData.evaluateScore" disabled placeholder="请选择">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="评价时间"  prop="evaluateTime">
                <el-input
                  v-model="addData.evaluateTime"
                  placeholder="无"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>    
          <el-row>
            <el-col :span="24">
              <el-form-item label="评价内容"  prop="evaluateDesc">
                  <el-input
                  v-model="addData.evaluateDesc"
                  placeholder="无"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>                
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isAddModal = false">确 定</el-button>
          <!-- <el-button type="primary" @click="submit" :loading="btnLoading"
            >确 定</el-button
          > -->
        </span>
      </el-dialog>        
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      tableData: [],
      isShowloading:false,
      isAddModal:false,
      btnLoading:false,
      addData:{
       
      },
      addDataRules:{

      },
      searchForm: {
        orderWorkNo: "",
      },
      options:[{
        value:1,
        label:'非常满意'
      },
      {
        value:2,
        label:'满意'
      },
      {
        value:3,
        label:'一般'
      }]
    };
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    updata(row) {
      this.modalTitle = "修改";
      this.isAddModal = true;
      this.addData = JSON.parse(JSON.stringify(row));
    },    
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },    
    submit() {

    },
    onLoad() {
      this.isShowloading = true;
      let page = {
        current: this.currentPage,
        size: this.pageSize,
        type:1,
        status:4,
        orderWorkNo:this.searchForm.orderWorkNo
      };
      this.tableData = [];
      this.$Apis.orderWorkList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
         let { current, list, pages, total } = res.data;
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        }
      });
    },
  },
};
</script>

<style  scoped>
/deep/.el-input.is-disabled .el-input__inner{
  color: #333;
  font-weight: bold;
  border: none;
  background: #fff;
}
</style>